import React, { useState, useEffect } from "react";
import { FaBolt, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function LogIn() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit login
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post("https://backend-zkgn.onrender.com/api/admin/login", formData);

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("username", res.data.admin.username);

        setMessage("Login successful ✅");

        setTimeout(() => navigate("/Admin"), 800);
      } else {
        setMessage("Unexpected response. Please try again.");
      }
    } catch (err) {
      if (err.response) {
        setMessage(err.response.data.message);
      } else {
        setMessage("Server error. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  // fade-in animation
  useEffect(() => {
    const card = document.querySelector(".login-card");
    if (card) card.classList.add("fade-in");
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1509395176047-4a66953fd231?auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Dark overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.55)",
        }}
      ></div>

      {/* Card */}
      <div
        className="login-card card shadow-lg p-4 position-relative"
        style={{
          width: "100%",
          maxWidth: "400px",
          borderRadius: "15px",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          zIndex: 2,
          opacity: 0,
          transform: "translateY(30px)",
          transition: "opacity 1s ease, transform 1s ease",
        }}
      >
        <div className="text-center mb-3">
          <FaBolt
            className="text-warning"
            size={36}
            style={{ animation: "float 3s ease-in-out infinite" }}
          />
        </div>

        <h3 className="text-center mb-4 text-primary fw-bold">Welcome Back</h3>

        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Email Address</label>
            <input
              type="email"
              className="form-control form-control-sm"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          {/* Password */}
          <div className="mb-3 position-relative">
            <label className="form-label fw-semibold">Password</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control form-control-sm"
                name="password"
                placeholder="Enter your password"
                value={formData.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setShowPassword(!showPassword)}
                style={{ backgroundColor: "white", borderLeft: "none" }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Button */}
          <div className="d-grid mt-4">
            <button
              type="submit"
              className="btn btn-primary btn-sm shadow-sm"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Log In"}
            </button>
          </div>
        </form>

        {/* Message */}
        {message && (
          <p className="text-center mt-3 mb-0 small" style={{ color: "#d9534f" }}>
            {message}
          </p>
        )}

        {/* Signup link */}
        <p className="text-center mt-3 mb-0 text-secondary small">
          Don’t have an account?{" "}
          <Link to="/register" className="text-decoration-none fw-semibold text-primary">
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}

export default LogIn;
